import React from 'react';
import { Box, Typography } from '@mui/material';
import { YouCard, SubScreenHeader } from './YouPrimitives';

const RED = '#e5484d';
const GREEN = '#3ddc97';
const TEXT_SECONDARY = 'rgba(255,255,255,0.7)';
const TEXT_MUTED = 'rgba(255,255,255,0.55)';
const TEXT_TERTIARY = 'rgba(255,255,255,0.4)';

const badgeSx = (open) => ({
  fontSize: 11,
  fontWeight: 700,
  lineHeight: 1.4,
  borderRadius: '20px',
  padding: '2px 8px',
  color: open ? RED : GREEN,
  backgroundColor: open ? 'rgba(229,72,77,0.16)' : 'rgba(61,220,151,0.16)',
});

export default function KnownIssuesSection({ items = [], onBack }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <SubScreenHeader title="Known issues" onBack={onBack} />

      {items.length === 0 ? (
        <Typography sx={{ textAlign: 'center', fontSize: 13, color: TEXT_TERTIARY }}>
          No known issues
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {items.map((item) => {
            const open = item.status === 'open';
            return (
              <YouCard key={item.id}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '8px' }}>
                  <Typography sx={badgeSx(open)}>{open ? 'OPEN' : 'FIXED'}</Typography>
                  {item.status === 'fixed' && item.version && (
                    <Typography sx={{ fontSize: 12, color: TEXT_MUTED }}>
                      {`· Fixed in ${item.version}`}
                    </Typography>
                  )}
                </Box>

                <Typography sx={{ fontSize: 15, fontWeight: 500, color: '#fff' }}>
                  {item.title}
                </Typography>

                {item.body && (
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 300,
                      color: TEXT_SECONDARY,
                      whiteSpace: 'pre-wrap',
                      mt: '6px',
                    }}
                  >
                    {item.body}
                  </Typography>
                )}
              </YouCard>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
